module.exports = __webpack_public_path__ + "static/media/gps-fixed.350c3cf6.svg";